var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCamera2 = function SvgCamera2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.515 11.387a4.252 4.252 0 1 0 0 8.505 4.252 4.252 0 1 0 0-8.505Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.756 5.347h-4.01a2.273 2.273 0 0 1-2.074-1.341l-1.2-2.666A2.275 2.275 0 0 0 23.398 0H11.632c-.895 0-1.707.525-2.075 1.34l-1.2 2.666a2.273 2.273 0 0 1-2.072 1.34H2.274A2.273 2.273 0 0 0 0 7.62v17.109A2.273 2.273 0 0 0 2.274 27h30.482a2.274 2.274 0 0 0 2.274-2.272V7.619a2.274 2.274 0 0 0-2.274-2.272ZM17.515 23.524a7.886 7.886 0 1 1 0-15.771 7.886 7.886 0 1 1 0 15.771Z",
    fill: "#A6A6A6"
  })));
};
export default SvgCamera2;